<template>
<div class="admin">
    <h1>Admin</h1>
</div>
</template>

<script>
export default {
    name: "Admin"
};
</script>

<style lang="scss" scoped>
.admin {
    padding: 50px 5%;
}
</style>
